import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useMediaQuery, useTheme } from "@mui/material";

const GrowthProcess = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(890));


    const styles = {
        container: {
            flex: 1
        },
        stepContainer: {
            display: "flex",
            alignItems: "center",
            gap: "20px",
            position: "relative",
        },
        timeline: {
            position: "absolute",
            left: "10px",
            width: "2px",
            height: "100%",
            backgroundColor: "#FFC107",
            zIndex: -1,
        },
        stepNumber: {
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            backgroundColor: "#FFC107",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            color: "#fff",
        },
        card: {
            width: "400px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "3px 3px 10px rgba(0,0,0,0.1)",
            padding: "10px",
        },
        stepLabel: {
            fontWeight: "bold",
            backgroundColor: "#000",
            color: "#fff",
            display: "inline-block",
            padding: "5px 10px",
            borderRadius: "5px",
            marginBottom: "10px",
        },
    };

    return (
        <Box sx={styles.container}>
            <Box sx={{ width: isMobile ? '95%' : '70%', marginLeft: 'auto' }}>
                <motion.div
                    initial={{ opacity: 0, y: 50, scale: 0.6 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: 0.5 }}
                    style={{ fontSize: isMobile ? "25px" : "35px", fontWeight: "bold", marginBottom: 20, marginTop: isMobile ? 60 : 100, textAlign: 'left' }}
                >
                    Our 3-Step Growth Process
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 50, scale: 0.6 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: 0.5 }}
                    style={{ fontSize: isMobile ? "15px" : "18px", marginBottom: 20, textAlign: 'left' }}
                >
                    With this process, we’ve been able to scale brands aggressively & profitably
                </motion.div>
            </Box>


            <Box style={{ width: isMobile ? '100%' : '80%', margin: '0px auto', marginTop: 80, display: 'flex', justifyContent: 'center' }}>
                {!isMobile && <Box style={{ width: '10%', position: 'relative' }}>
                    <span style={{ fontWeight: 'bold', borderRadius: '50%', backgroundColor: '#FFC107', color: '#fff', padding: '15px 20px' }}>1</span>
                    <div style={{ borderLeft: '2px dashed #FFC107', height: '100%', position: 'absolute', top: '65%', left: '20%', transform: 'translate(-50%, -50%)' }}></div>
                </Box>}
                <Box
                    sx={{
                        width: isMobile ? '90%' : '80%',
                        border: '1px solid #000',
                        borderRadius: '20px',
                        padding: isMobile ? '30px 20px' : '30px 50px',
                        boxSizing: 'border-box',
                        position: 'relative',
                        '&::after': {
                            content: '"Step-01"',
                            position: 'absolute',
                            top: '-25px',
                            left: '50px',
                            background: '#000',
                            color: '#fff',
                            borderRadius: '25px',
                            padding: '15px 20px',
                            fontSize: '20px',
                            fontWeight: 'bold',
                        }
                    }}
                >
                    {isMobile ? <h2>Deep Research</h2> : <h1>Deep Research</h1>}
                    <div style={{ lineHeight: '2' }}>
                        Before spending any money on ads, it's essential to deeply understand our target audience. In the first stage of our onboarding process, we conduct thorough research to create a detailed buyer persona, covering more than just basic demographics. We explore their interests, communication style, social habits, and more to ensure a comprehensive understanding.
                    </div>
                </Box>
            </Box>


            <Box style={{ width: isMobile ? '100%' : '80%', margin: '50px auto', display: 'flex', justifyContent: 'center' }}>
                {!isMobile && <Box style={{ width: '10%', position: 'relative' }}>
                    <span style={{ fontWeight: 'bold', borderRadius: '50%', backgroundColor: '#FFC107', color: '#fff', padding: '15px 20px' }}>2</span>
                    <div style={{ borderLeft: '2px dashed #FFC107', height: '100%', position: 'absolute', top: '65%', left: '20%', transform: 'translate(-50%, -50%)' }}></div>
                </Box>}
                <Box
                    sx={{
                        width: isMobile ? '90%' : '80%',
                        border: '1px solid #000',
                        borderRadius: '20px',
                        padding: isMobile ? '30px 20px' : '30px 50px',
                        boxSizing: 'border-box',
                        position: 'relative',
                        '&::after': {
                            content: '"Step-02"',
                            position: 'absolute',
                            top: '-25px',
                            left: '50px',
                            background: '#000',
                            color: '#fff',
                            borderRadius: '25px',
                            padding: '15px 20px',
                            fontSize: '20px',
                            fontWeight: 'bold',
                        }
                    }}
                >
                    {isMobile ? <h2>Crafting Assets & Execution</h2> : <h1>Crafting Assets & Execution</h1>}
                    <div style={{ lineHeight: '2' }}>
                        No matter your marketing stage, we prioritize establishing a robust understanding rooted in reliable  data. This ensures future growth without fear of collapse. We then execute a detailed plan, focusing  on strategic implementation and scalability to achieve your goals efficiently.
                    </div>
                </Box>

            </Box>


            <Box style={{ width: isMobile ? '100%' : '80%', margin: '50px auto', display: 'flex', justifyContent: 'center' }}>
                {!isMobile && <Box style={{ width: '10%' }}>
                    <span style={{ fontWeight: 'bold', borderRadius: '50%', backgroundColor: '#FFC107', color: '#fff', padding: '15px 20px' }}>3</span>
                </Box>}
                <Box
                    sx={{
                        width: isMobile ? '90%' : '80%',
                        border: '1px solid #000',
                        borderRadius: '20px',
                        padding: isMobile ? '30px 20px' : '30px 50px',
                        boxSizing: 'border-box',
                        position: 'relative',
                        '&::after': {
                            content: '"Step-03"',
                            position: 'absolute',
                            top: '-25px',
                            left: '50px',
                            background: '#000',
                            color: '#fff',
                            borderRadius: '25px',
                            padding: '15px 20px',
                            fontSize: '20px',
                            fontWeight: 'bold',
                        }
                    }}
                >
                   {isMobile ? <h2>Full Scaling Mode ON</h2> : <h1>Full Scaling Mode ON</h1>}
                    <div style={{ lineHeight: '2' }}>
                        After numerous iterations, we've crafted numerous high-return ad combinations and gained deep  insights into your ideal customer. This empowers us to increase ad spend while maintaining predictability and profitability, leading to a notable increase in orders.
                    </div>
                </Box>

            </Box>

        </Box>
    );
};

export default GrowthProcess;
